/**
 * Href Enumeration
 */
export enum HrefEnum {
  CARD_DOCUMENTATION = "https://soporte.kushkipagos.com/hc/es/articles/1500003847842--Cómo-hacer-pagos-con-Tarjeta-de-Crédito-mediante-la-Cajita-de-Pagos-Kushki-",
  PSE_DOCUMENTATION = "https://soporte.kushkipagos.com/hc/es/articles/1500010819081--C%C3%B3mo-hacer-pagos-con-PSE-mediante-Kushki-",
}



// WEBPACK FOOTER //
// ./src/shared/HrefEnum.ts